
const digest = '34ad26f60e5c4352eb61bebb7fb6f99429cff92f791e2bd08671cec12602d62c';
const classes = {"wrapper":"_wrapper_1154n_1","header":"_header_1154n_10","list":"_list_1154n_16","title":"_title_1154n_21"};
const css = `._wrapper_1154n_1 {
  background-color: #ffffff;
  border: 1px solid #eaedf3;
  font-family: Rubik, sans-serif;
  height: 100%;
  overflow-y: auto;
  padding: 20px;
  position: relative;
}
._wrapper_1154n_1 ._header_1154n_10 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
}
._wrapper_1154n_1 ._list_1154n_16 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_1154n_1 ._title_1154n_21 {
  font-weight: 600;
  margin-bottom: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  